import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigation, useStandingOrders } from 'msp-integrations'
import { DynamicTag, PageActionPlaceHolder, Spinner } from 'msp-components'
import { StandingOrdersItem } from './StandingOrdersItem'
import { translations } from '../AccountStandingOrders.constants'
import * as S from '../AccountStandingOrders.styles'

const StandingOrdersHelpText = (): JSX.Element => {
  const { formatMessage } = useIntl()
  const helpTextTranslations = [
    translations.placeholderTextIntro,
    translations.placeholderTextBeforeSteps,
    translations.placeholderTextStep1,
    translations.placeholderTextStep2,
    translations.placeholderTextStep3,
    translations.placeholderTextStep4,
    translations.placeholderTextAfterSteps
  ]

  return (
    <div className='px-8'>
      {helpTextTranslations.map((text, ind) => (
        <div
          key={text.id}
          className={`${S.HelpTextWrapper} ${
            ind === 1 || ind === helpTextTranslations.length - 1
              ? 'mt-6'
              : 'mt-2'
          }`}
        >
          {formatMessage(text)}
        </div>
      ))}
    </div>
  )
}

const StandingOrdersNoResults = () => {
  const navigate = useNavigation()
  const { formatMessage } = useIntl()

  return (
    <PageActionPlaceHolder
      iconName='Receipt'
      heading={formatMessage(translations.placeholderTitle)}
      text={<StandingOrdersHelpText />}
      buttonText={formatMessage(translations.buttonText)}
      onButtonClick={() => navigate('/account/orders')}
    />
  )
}

const StandingOrdersList = () => {
  const { formatMessage } = useIntl()
  const { isLoading, getAll } = useStandingOrders()

  const standingOrders = getAll()
  return (
    <>
      <DynamicTag
        componentTagName='Headline'
        tag='h6'
        className='font-Roboto mb-4'
      >
        {formatMessage(translations.title)}
      </DynamicTag>
      {isLoading && <Spinner />}
      {!isLoading && standingOrders?.length === 0 && (
        <StandingOrdersNoResults />
      )}
      {standingOrders?.length > 0 && (
        <>
          <div className={S.SubTitle}>
            {formatMessage(translations.subTitle, {
              amount: standingOrders?.length
            })}
          </div>
          {standingOrders?.map((order) => (
            <StandingOrdersItem key={order.id} order={order} />
          ))}
        </>
      )}
    </>
  )
}

export default StandingOrdersList
